"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _listItemField = _interopRequireDefault(require("./list-item-field"));

var _attach = _interopRequireDefault(require("../attach"));

var _button = _interopRequireDefault(require("../button"));

var _commonField = _interopRequireDefault(require("./common-field"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ListField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ListField, _React$PureComponent);

  var _super = _createSuper(ListField);

  function ListField() {
    var _this;

    (0, _classCallCheck2.default)(this, ListField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNew", function () {
      _this.props.component.createField(); // Reset the touched state so that errors aren't reported immediately when the user hasn't
      // finished entering the new value.


      _this.props.component.set({
        touched: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ListField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          allowDelete = _this$props.allowDelete,
          useDisplayValue = _this$props.useDisplayValue,
          autoCreateFields = _this$props.autoCreateFields,
          hideLabel = _this$props.hideLabel,
          editable = _this$props.editable,
          canDeleteEmpty = _this$props.canDeleteEmpty,
          accessEditable = _this$props.accessEditable,
          disabled = _this$props.disabled,
          hideDeleteButton = _this$props.hideDeleteButton;
      var singularLabel = component.getSingularLabel();
      var dis = accessEditable === false || disabled;
      var fields = [];
      var first = true;
      var isBlank = component.isBlank();
      component.eachField(function (field, index) {
        var fieldIsBlank = field.isBlank(); // When using the display value, we hide any blank fields, e.g. the empty "next" fields

        if (first || !useDisplayValue || !fieldIsBlank) {
          // We have to pass allowDelete as it is the allowDelete of the parent
          fields.push( /*#__PURE__*/_react.default.createElement(_listItemField.default, {
            component: field,
            key: index,
            allowDelete: allowDelete && !useDisplayValue && (canDeleteEmpty || !fieldIsBlank) && !hideDeleteButton,
            disabled: disabled
          }));
        }

        if (first) {
          first = false;
        }
      });

      if (!autoCreateFields && !useDisplayValue && editable && !dis) {
        fields.push( /*#__PURE__*/_react.default.createElement(_button.default, {
          key: "button",
          "aria-label": "add",
          onClick: this.handleNew,
          icon: "Add",
          label: 'Add ' + (singularLabel ? singularLabel : ''),
          marginTop: false
        }));
      }

      return /*#__PURE__*/_react.default.createElement("span", null, !hideLabel && /*#__PURE__*/_react.default.createElement(_commonField.default, {
        component: component,
        inlineLabel: "true",
        marginBottom: false,
        shrinkLabel: !isBlank
      }), /*#__PURE__*/_react.default.createElement("div", null, fields));
    }
  }]);
  return ListField;
}(_react.default.PureComponent); // We want the component to update when we receive new fields


var _default = (0, _attach.default)(['change', 'help', 'allowDelete', 'useDisplayValue', 'autoCreateFields', 'hideLabel', 'value', 'editable', 'canDeleteEmpty', 'disabled', 'hideDeleteButton', 'singularLabel', 'label'])(ListField);

exports.default = _default;